import { AbstractControl } from '@angular/forms';

const isShortTimeFormatWithoutLeadingZero = ({ length }) => length === 5 || length === 8;
const time = ({ value }) => (isShortTimeFormatWithoutLeadingZero(value) ? value : `0${value}`);

export default (control: AbstractControl) => {
  const from = control.get('from');
  const to = control.get('to');

  if (!from || !to) {
    return null;
  }

  return time(from) < time(to) ? null : { invalidTime: true };
};
